/**
 * Generates the callback URL after template deployment based on context.
 *
 * Routes users to different destinations depending on where they initiated the deployment:
 * - Marketplace flow: Navigate to the specific deployment detail page
 * - Regular template flow: Navigate back to the deployments list page
 *
 * @param isFromMarketplace - Whether the deployment was initiated from the marketplace
 * @param templateId - The template ID
 * @param versionId - The version ID
 * @param deploymentId - The deployment ID (required for marketplace deployments)
 * @returns The callback URL path
 */
export const generateCallbackUrl = (
  isFromMarketplace: boolean | undefined,
  templateId: string,
  versionId: string,
  deploymentId?: string
): string => {
  if (isFromMarketplace) {
    if (!deploymentId) {
      // Fallback to deployments list if deploymentId is missing
      console.warn(
        "generateCallbackUrl: deploymentId missing for marketplace flow, falling back to deployments list"
      );
      return `/template/${templateId}/version/${versionId}/deployments`;
    }
    return `/templates/template/${templateId}/deployment/${deploymentId}`;
  }
  return `/template/${templateId}/version/${versionId}/deployments`;
};
